import { render, staticRenderFns } from "./ProcedimientosList.vue?vue&type=template&id=9b72df4a"
import script from "./ProcedimientosList.vue?vue&type=script&lang=js"
export * from "./ProcedimientosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports